import React from 'react'

const Footer = () => {
   return (
      <div>
         <footer className="main-footer text-center">
            Copyright © 2024 All rights reserved.
            {/* <div className="float-right d-none d-sm-inline-block">
               <b>Version</b> 3.2.0
            </div> */}
         </footer>
         <aside className="control-sidebar control-sidebar-dark">
         </aside>
      </div>

   )
}

export default Footer
